import { NgZone, ApplicationRef, Injector } from '@angular/core';
import { Router } from '@angular/router';
// import { IdsModalSettings } from 'ids-enterprise-wc/components/ids-modal/ids-modal';
// import IdsModalFullsizeAttributeValue from 'ids-enterprise-wc/components/ids-modal/ids-modal';
import {
  // ComponentType,
  // IdsModalDialogEventFunction,
  // IdsModalDialogEventVetoFunction,
  // IdsModalDialogRef,
  LMContextService,
  LMModalOpenService
} from '@app/services';
import { SohoModalDialogEventFunction, SohoModalDialogEventVetoFunction, SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';
// import IdsButton from 'ids-enterprise-wc/components/ids-button/ids-button';
// import IdsModalButtonProps from 'ids-enterprise-wc/components/ids-modal/ids-modal-button';

/**
 * Wrapper for the jQuery modal control.
 *
 */
export class LMModalDialogWrapperRef<T> {

  private beforeCloseMethod = (): boolean => {
    if (this.lmContextService.isUnified()) {
      this.lmModalOpenService.removeModal(this.uuid);
    }
    return true;
  };

  /**
   * The component displayed inside the modal frame, if specified.  This may
   * be null if the dialog is built from an HTML fragment or a jQuery selector.
   *
   * @returns the contained component dialog.
   */
  public get componentDialog(): T | undefined {
    // if (this.useWc && this.idsDialog) {
    //   return this.idsDialog.componentDialog;
    // } else
    if (this.dialog) {
      return this.dialog.componentDialog;
    }
  }

  /**
   * The buttonset API for the modal dialog.
   *
   * @returns the buttonset API for the modal dialog, if initialised.
   */
  public get buttonsetAPI(): SohoButtonsetStatic | undefined {
    // if (this.useWc && this.idsDialog) {
    //   return this.idsDialog.buttonset;
    // } else
    if (this.dialog) {
      return this.dialog.buttonsetAPI;
    }
  }

  /**
   * Sets the whole options block for this modal dialog.
   *
   * @param options - the options to set.
   */
  options(options: SohoModalOptions): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.options(options as IdsModalSettings);
    // } else
    if (this.dialog) {
      this.dialog.options(options as SohoModalOptions);
    }
    return this;
  }

  /**
   * Sets the frame height for the dialog.
   *
   * @param frameHeight - the extra frame height to allow.
   */
  frameHeight(frameHeight: number): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop
    // } else
    if (this.dialog) {
      this.dialog.frameHeight(frameHeight);
    }
    return this;
  }

  /**
   * Sets the frame width for the dialog.
   *
   * @param frameWidth - the extra frame width to allow.
   */
  frameWidth(frameWidth: number): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop
    // } else
    if (this.dialog) {
      this.dialog.frameHeight(frameWidth);
    }
    return this;
  }

  /**
   * A call back function that can be used to return data for the modal. This is the callback form of the before show event.
   *
   * @param beforeShow - The callback function
   */
  beforeShow(beforeShow: any): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop
    // } else
    if (this.dialog) {
      this.dialog.beforeShow(beforeShow);
    }
    return this;
  }

  /**
   * If true, show a close icon button on the top right of the modal.
   *
   * @param showCloseBtn - if true the x will be shown.
   */
  showCloseBtn(showCloseBtn: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.showCloseBtn(showCloseBtn);
    // } else
    if (this.dialog) {
      this.dialog.showCloseBtn(showCloseBtn);
    }
    return this;
  }

  /**
   * Optional max width to add in pixels.
   *
   * @param maxWidth - The width in pixels
   */
  maxWidth(maxWidth: number): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop
    // } else
    if (this.dialog) {
      this.dialog.maxWidth(maxWidth);
    }
    return this;
  }

  /**
   * Optional width to set the text of the buttonset.
   *
   * @param buttonsetTextWidth - The width of buttonset text.
   */
  buttonsetTextWidth(buttonsetTextWidth: number | string): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop
    // } else
    if (this.dialog) {
      this.dialog.buttonsetTextWidth(buttonsetTextWidth);
    }
    return this;
  }

  /**
   * Sets the title of the modal dialog.
   *
   * @param title - the title of the dialog.
   */
  title(title: string): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.title(title);
    // } else
    if (this.dialog) {
      this.dialog.title(title);
    }
    return this;
  }

  /**
   * Sets the icon of the modal dialog title
   * @param icon - the icon name without icon-
   */
  icon(icon: string): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop
    // } else
    if (this.dialog) {
      this.dialog.icon(icon);
    }
    return this;
  }

  /**
   * Sets the class to add for color and placement on the icon
   * @param iconClass - the css class name
   */
  iconClass(iconClass: string): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop
    // } else
    if (this.dialog) {
      this.dialog.iconClass(iconClass);
    }
    return this;
  }


  /**
   * Sets the buttons to use on the modal dialog.
   *
   * @param buttons - list of buttons to display
   */
  buttons(buttons: SohoModalButton[]): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop. No way to programmatically change the buttons currently
    // } else
    if (this.dialog) {
      this.dialog.buttons(buttons as SohoModalButton[]);
    }
    return this;
  }

  /**
   * Sets the 'id' that the modal control uses.
   *
   * @param id - the id.
   */
  id(id: string): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop. No way to programmatically change the id currently
    // } else
    if (this.dialog) {
      this.dialog.id(id);
    }
    return this;
  }

  /**
   * Sets the 'trigger' that the modal control uses.
   *
   * @param trigger - when to open the dialog.
   */
  trigger(trigger: SohoModalTriggerType): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.trigger(trigger);
    }
    return this;
  }

  /**
   * Sets the 'isAlert' that the modal control uses.
   *
   * @param isAlert - true if this dialog is to be styled an an alert.
   */
  isAlert(isAlert: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.isAlert(isAlert);
    }
    return this;
  }

  /**
   * Sets the fullsize configuration that the modal control uses.
   *
   * @param fullsize - The full size configuration to use.
   */
  fullsize(fullsize: SohoModalFullSize): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.fullsize(fullsize);
    }
    return this;
  }

  /**
   * Sets the breakpoint configuration that the modal control uses in full size mode(s).
   *
   * @param breakpoint - The full size configuration to use.
   */
  breakpoint(breakpoint: SohoModalBreakPoint): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.breakpoint(breakpoint as IdsModalFullsizeAttributeValue);
    // } else
    if (this.dialog) {
      this.dialog.breakpoint(breakpoint as SohoModalBreakPoint);
    }
    return this;
  }

  /**
   * Controls the opacity of the background overlay.
   *
   * @param overlayOpacity - The percent between 0 and 1 of opacity to use.
   */
  overlayOpacity(overlayOpacity: number): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.overlayOpacity(overlayOpacity);
    }
    return this;
  }

  /**
   * Causes this modal instance to become hidden when another modal is displayed over top.
   *
   * @param hideUnderneath - If it should be on top or bottom.
   */
  hideUnderneath(hideUnderneath: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.hideUnderneath(hideUnderneath);
    }
    return this;
  }

  /**
   * if true, causes the modal to not exit when the enter key is pressed.
   *
   * @param suppressEnterKey - If it suppress enter
   */
  suppressEnterKey(suppressEnterKey: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.suppressEnterKey(suppressEnterKey);
    }
    return this;
  }

  /**
   * If true, causes the modal's trigger element not to become focused once the modal is closed.
   *
   * @param noRefocus - If true, refocus
   */
  noRefocus(noRefocus: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.noRefocus(noRefocus);
    }
    return this;
  }

  /**
   * The modal's trigger element to keep refocused once the modal is closed. This can be html or jquery object or query selector as string.
   *
   * @param triggerButton - The element (for example a button) to refocus on close.
   */
  triggerButton(triggerButton: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.triggerButton(triggerButton);
    }
    return this;
  }

  /**
   * Add extra attributes like id's to the component
   */
  attributes(attributes: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.attributes(attributes);
    }
    return this;
  }

  /**
   * Sets the 'content' that the modal control uses.
   *
   * @param content - a selector or string representing the dialog content.
   */
  content(content: JQuery | string): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop. IDSModal only currently supports a html string, not a selector
    // } else
    if (this.dialog) {
      this.dialog.content(content);
    }
    return this;
  }

  /**
   * Sets the 'cssClass' of the modal control.
   */
  cssClass(cssClass: string): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.cssClass(cssClass);
    }
    return this;
  }

  /**
   * Sets the 'autoFocus' of the modal control.
   *
   * @param autoFocus -if true; the dialog will autoFocus.
   */
  autoFocus(autoFocus: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.autoFocus(autoFocus);
    }
    return this;
  }

  /**
   * Sets the 'noPadding' to remove paddings from the modal body wrapper.
   * @param noPadding - if true; the content will have no paddings.
   */
  noPadding(noPadding: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.noPadding(noPadding);
    }
    return this;
  }

  /**
   * Applies a function to the instantiated component,
   * allowing the component to be modified, or initialised.
   *
   * The function is provided with a typed value for the
   * instance.
   *
   * @param component - the instantated instance.
   * @return the dialog ref for onward assignment.
   */
  apply(fn: (component: T) => void): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.apply(fn);
    // } else
    if (this.dialog) {
      this.dialog.apply(fn);
    }
    return this;
  }

  /**
   * When set to true, this dialog is closed when navigation is detected.
   *
   * @param closeOnNavigation controls the close behaviour when navigating.
   * @return the dialog ref for support a fluent api.
   */
  closeOnNavigation(closeOnNavigation: boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   // not implemented for IDSModal, noop.
    // } else
    if (this.dialog) {
      this.dialog.closeOnNavigation(closeOnNavigation);
    }
    return this;
  }

  /**
   * Dialog result property.
   *
   * @param dialogResult - the stored restult of the dialog.
   */
  set dialogResult(dialogResult: any) {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.dialogResult(dialogResult);
    // } else
    if (this.dialog) {
      this.dialog.dialogResult(dialogResult);
    }
  }
  get dialogResult(): any {
    // if (this.useWc && this.idsDialog) {
    //   return this.idsDialog.dialogResult;
    // } else
    if (this.dialog) {
      return this.dialog.dialogResult;
    }
  }

  // private useWc = false;
  private dialog: SohoModalDialogRef<any> | undefined;
  // private idsDialog: IdsModalDialogRef<any> | undefined;
  private _uuid = 0;

  get isWebComponent(): boolean {
    return false;
  }

  get uuid(): number {
    return this._uuid;
  }

  /**
   * Constructor.
   *
   * @paran appRef - application reference used to insert the component.
   */
  constructor(
    appRef: ApplicationRef,
    injector: Injector,
    ngZone: NgZone,
    private lmModalOpenService: LMModalOpenService,
    private lmContextService: LMContextService,
    sohoSettings?: SohoModalOptions,
    modalComponent?: ComponentType<T>) {
    if (this.lmContextService.isUnified()) {
      this._uuid = Date.now();
    }
    // this.useWc = lmContextService.useWebComponents();

    // if (this.useWc) {
    //   this.idsDialog = new IdsModalDialogRef(router, appRef, ngZone, renderer2, idsSettings, modalComponent);
    // } else {
    if (sohoSettings) {
      const router: Router = injector.get(Router);
      const sohoModalDialogService: SohoModalDialogService = injector.get(SohoModalDialogService);
      this.dialog = new SohoModalDialogRef(router, appRef, injector, ngZone, sohoModalDialogService, sohoSettings, modalComponent);

      // default the beforeClose callback if in unified mode, to make sure messages are removed from the
      // open modal/message collection
      if (this.lmContextService.isUnified()) {
        this.dialog.beforeClose(this.beforeCloseMethod);
      }
    }
    // }

  }

  /**
   * Opens the dialog.
   *
   * @return the dialog ref.
   */
  open(): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.open();
    // } else
    if (this.dialog) {
      if (this.lmContextService.isUnified()) {
        this.lmModalOpenService.addModal(this.uuid, this);
      }
      this.dialog.open();
    }
    return this;
  }

  /**
   * Closes the modal dialog, if open.  The dialog is not closed
   * fully until the 'afterClosed' event is fired.
   *
   * @param dialogResult - optional result - passed back to the caller.
   */
  close(dialogResult?: any): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.close(dialogResult);
    // } else
    if (this.dialog) {
      this.dialog.close(dialogResult);
    }
    return this;
  }

  /**
   * Destroys the modal dialog.
   */
  destroy(): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.destroy();
    // } else
    if (this.dialog) {
      this.dialog.destroy();
    }
    return this;
  }

  // ------------------------------------------
  // Events
  // ------------------------------------------

  /**
   * Registers a before open guard.
   *
   * @param eventFn - the function to call before opening the dialog.
   */
  beforeOpen(eventFn: (dialogRef?: SohoModalDialogRef<T>) => boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.beforeOpen(eventFn);
    // } else
    if (this.dialog) {
      this.dialog.beforeOpen(eventFn);
    }
    return this;
  }

  /**
   * Opened Event.
   *
   * This event is fired when the dialog is being opened.
   *
   * @param eventFn - the function to invoke when the dialog is to be opened.
   */
  opened(eventFn: SohoModalDialogEventFunction<T>): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.opened(eventFn);
    // } else
    if (this.dialog) {
      this.dialog.opened(eventFn);
    }
    return this;
  }

  /**
   * Opened Event.
   *
   * This event is fired after the dialog has been opened.
   *
   * @param eventFn - the function to invoke when the dialog is to be opened.
   */
  afterOpen(eventFn: SohoModalDialogEventFunction<T>): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.afterOpen(eventFn as IdsModalDialogEventVetoFunction<T>);
    // } else
    if (this.dialog) {
      this.dialog.afterOpen(eventFn as SohoModalDialogEventVetoFunction<T>);
    }
    return this;
  }

  /**
   * Registers a before close guard.
   *
   * @param eventFn - the function to call before closing the dialog.
   */
  beforeClose(eventFn: SohoModalDialogEventVetoFunction<T>): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.beforeClose(eventFn as IdsModalDialogEventVetoFunction<T>);
    // } else
    if (this.dialog) {
      this.dialog.beforeClose(eventFn as SohoModalDialogEventVetoFunction<T>);
    }
    return this;
  }

  /**
   * Closed Event.
   *
   * This event is fired when the dialog is being closed.
   *
   * @param eventFn - the function to invoke when the dialog is to be closed.
   */
  closed(eventFn: SohoModalDialogEventFunction<T>): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.closed(eventFn as IdsModalDialogEventFunction<T>);
    // } else
    if (this.dialog) {
      this.dialog.closed(eventFn as SohoModalDialogEventFunction<T>);
    }
    return this;
  }

  /**
   * After Closed Event.
   *
   * This event is fired, with the result of the dialog, when the dialog has been
   * closed and destroyed.
   *
   * @param eventFn - the function to invoke after the dialog has been closed.
   */
  afterClose(eventFn: SohoModalDialogEventFunction<T>): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.afterClose(eventFn as IdsModalDialogEventFunction<T>);
    // } else
    if (this.dialog) {
      this.dialog.afterClose(eventFn as SohoModalDialogEventFunction<T>);
    }
    return this;
  }

  /**
   * Registers a before destroy guard.
   *
   * SOHO-4892 - Returning false from beforeOpen or beforeDestroy breaks dialogs
   *
   * @param eventFn - the function to call before destroying the dialog.
   */
  beforeDestroy(eventFn: () => boolean): LMModalDialogWrapperRef<T> {
    // if (this.useWc && this.idsDialog) {
    //   this.idsDialog.beforeDestroy(eventFn);
    // } else
    if (this.dialog) {
      this.dialog.beforeDestroy(eventFn);
    }
    return this;
  }
}

/**
 * Object with a "new"" method returning the type T.
 */
export type ComponentType<T> = new (...args: any[]) => T;
